import { GriffelStyle, shorthands } from "@fluentui/react-components"
import { slThemeLight } from "./slTheme";

export class slStyles
{
    static detailContainer: GriffelStyle =
        {
            display: 'flex',
            flexDirection: 'column',
            maxWidth: '8in',
            rowGap: '10pt',
        };

    static detailHeader: GriffelStyle =
        {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'end',
            fontFamily: slThemeLight.fontFamilyBase,
            paddingLeft: '4pt'
        };

    static detailBoxed: GriffelStyle =
        {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'top',
            fontFamily: slThemeLight.fontFamilyBase,
            border: '2pt  solid ' + slThemeLight.colorNeutralForeground1,
            minHeight: '1in',
            padding: '2pt'
        };

    static detailHeaderHeroText: GriffelStyle =
        {
            fontSize: slThemeLight.fontSizeBase500
        };
}

export class rexDataGridStyles
{
    static headerRow: GriffelStyle =
    {
        ...shorthands.borderBottom('2pt', 'solid', slThemeLight.colorBrandForeground1),
    };

    static headerCellProps: GriffelStyle =
    {
        fontWeight: 'bold'
    }

    static gridTable: GriffelStyle =
    {
        ...shorthands.border('2pt', 'solid', slThemeLight.colorBrandForeground1),
        ...shorthands.margin("2pt", "0pt", "0pt", "0pt")
    };

    static styles =
    {
        gridTable: rexDataGridStyles.gridTable,
        headerRow: rexDataGridStyles.headerRow,
        headerCellProps: rexDataGridStyles.headerCellProps
    }
}